import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface'

export type CompletedUploadFile = {
	uid?: string
	id: number
	name: string
	isDone: true
}

export type UploadFileListItem = UploadFile | CompletedUploadFile

export const isCompletedUploadFile = (file: UploadFileListItem): file is CompletedUploadFile => {
	return 'isDone' in file && file.isDone === true
}

type MergeUploadFileListOptions = {
	info: UploadChangeParam<UploadFile<any>>
	previous: UploadFileListItem[]
}

export const mergeUploadFileListOnChange = ({ info, previous }: MergeUploadFileListOptions): UploadFileListItem[] => {
	const completed = previous.filter(isCompletedUploadFile)
	const completedUids = new Set(completed.map((file) => file.uid).filter(Boolean))

	if (info.file.status === 'error') {
		const inProgress = info.fileList.filter((file) => file.uid !== info.file.uid && !completedUids.has(file.uid))
		return [...completed, ...inProgress]
	}

	if (info.file.status === 'done' || info.file.status === 'success') {
		const newCompleted: CompletedUploadFile = {
			uid: info.file.uid,
			id: info.file?.response?.file?.id,
			name: info.file?.response?.file?.name,
			isDone: true
		}
		const otherCompleted = completed.filter((file) => file.uid !== info.file.uid)
		const inProgress = info.fileList.filter((file) => file.uid !== info.file.uid && !completedUids.has(file.uid))

		return [...otherCompleted, ...inProgress, newCompleted]
	}

	const inProgress = info.fileList.filter((file) => !completedUids.has(file.uid))
	return [...completed, ...inProgress]
}
